import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import LoginSVG from "../../assets/login.svg";
import { LoadingButton } from "@mui/lab";
import { Notify } from "notiflix";
import AuthWrapper from "../components/AuthWrapper";
import { makeRequest } from "../../util/AxiosInstance";
import { isEmpty } from "underscore";
import DisplayAlerts from "../../shared/DisplayAlerts";
import { useNavigate, useParams } from "react-router-dom";
import { handleError, sleep } from "../../util/functions";
import PasswordField from "../../shared/PasswordField";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccessMsg, setApiSuccessMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = (e) => {
    e.preventDefault()
    if (isEmpty(newPassword) || isEmpty(confirmPassword)) {
      setApiErrors('Please enter a password');
      return;
    }
    if (newPassword !== confirmPassword) {
      setApiErrors('New passwords do not match');
      return;
    }
    setApiErrors(null);
    setLoading(true);
    makeRequest('post', `/reset-password/${token}`, {
      password: newPassword,
      confirm_password: confirmPassword,
    }).then(async (res) => {
      if (res.status === 200) {
        setApiSuccessMsg('Password changed successfully, logging out...');
        Notify.success('Password changed successfully');
        await sleep(1000);
        setNewPassword('');
        setConfirmPassword('');
        setApiSuccessMsg(null);
        setApiErrors(null);
        window.location.href = '/login'
      }
    })
      .catch((error) => {
        let msg = handleError(error);
        setApiErrors(msg);
        Notify.failure(msg);
        console.error(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  return (
    <AuthWrapper
      left={<>
        <Box>
          <Typography variant="h4" mb="1rem" fontWeight={'semibold'} align="left" gutterBottom>Reset Password</Typography>
          <Typography mb="1rem" variant="body2" align="left" gutterBottom>
            Enter your email to reset your password
          </Typography>
          <DisplayAlerts apiErrors={apiErrors} success={apiSuccessMsg} />
          {!token ? <>
            <Alert severity="error">
              No token provided. Please check your email for the proper reset link.
            </Alert>
            <Typography mt={2} mb={2} variant="body2">
              If you did not receive the email, please check your spam folder.
            </Typography>
            <Button mt={2} onClick={() => navigate('/login')} variant="contained" color="primary">Login</Button>
          </> : <>
            <form autoComplete="on" className="authForm" onSubmit={handlePasswordChange}>

              <PasswordField
                fullWidth
                label="Password"
                name="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disableCheck={false}
                aria-describedby="password-helper-text"
                autoComplete="current-password"
              />
              <PasswordField
                fullWidth
                label="Password"
                name="password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value)
                }}
                disableCheck={false}
                aria-describedby="password-helper-text"
                autoComplete="current-password"
              />

              {/* <TextField
                fullWidth
                label="Confirm New Password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              /> */}
              <LoadingButton
                variant="contained"
                type="submit"
                fullWidth
                color="primary"
                loading={loading}
              >
                Submit
              </LoadingButton>

            </form>
          </>}

        </Box>
      </>}

      right={<>
        <div
          style={{
            width: "80%",
            height: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={LoginSVG} alt="" />
        </div>
      </>}
    />
  );
}

export default ResetPassword;
